import { getItem } from "../utils/storage.helper";

const isAuthenticateed = (): boolean => {
  const data = getItem(import.meta.env.VITE_ACCESSTOKEN);
  return Boolean(data && data.rsa);
};

export default isAuthenticateed;
